export default __webpack_public_path__ + "static/media/globe_menu.c35ea2f6.png";